<template>
    <div class="accordion-item">
        <h2 class="accordion-header" id="delivery-address">
            <button class="accordion-button" type="button" @click="$helper.toggleAccordion(2, true);">
                {{ $helper.trans('Receiving_address') }}
            </button>
        </h2>
        <div id="delivery-address-content" class="accordion-collapse collapse" aria-labelledby="delivery-address" data-parent="#delivery-address-parent">
            <div class="select-address" v-if="$store.state.inClientAdmin">
                <select2-component :values="addressValues" :placeholder="$helper.trans('Select_address')" classes="input-big select-style-ups" v-model="selectedAddressId" :noLang="true" :useIndexes="true" dropDownClass="select2_customization"></select2-component>
                <i style="top:unset;right: unset;margin-left: 300px;" v-if="$store.state.$siteSettings['Logged_in']" class="select-address-icon" @click="openAddressSelectorModal(isImport ? 'receiver' : 'user');"></i>
            </div>
            <label for="op-14" class="custom-checkbox-wrap save-like-new-address" v-if="$store.state.$siteSettings['Logged_in']" :class="{ 'web-save-like-new-address': $store.state.$siteSettings['Logged_in'] && !$store.state.inClientAdmin }">
                {{ $helper.trans('Save_like_new_address') }}
                <input type="checkbox" v-model="$store.state.deliveryAddressInformation.saveLikeNewAddress" id="op-14">
                <span class="checkmark"></span>
            </label>
            <label class="new-address" v-if="$store.state.inClientAdmin">{{ $helper.trans('Address') }}</label>
            <div class="accordion-body" :class="{ 'pt-0': $store.state.inClientAdmin }">
                <div class="row mr-md-5 mr-2 w-100 deliveryAddressInformation">
                    <div class="col-12 col-md-6">
                        <div class="mb-3">
                            <input type="text" v-model="$store.state.deliveryAddressInformation.companyOrSender" :placeholder="'* ' + $helper.trans('Company_or_firstname_lastname')" class="input-big w-100 deliveryAddressInformation_companyOrSender_input" />
                        </div>
                        <div class="mb-3">
                            <input type="text" v-model="$store.state.deliveryAddressInformation.contactPerson" :placeholder="'* ' + $helper.trans('Contact_person')" class="input-big w-100 deliveryAddressInformation_contactPerson_input" />
                        </div>
                        <div class="mb-3">
                            <input type="text" v-model="$store.state.deliveryAddressInformation.phone" :placeholder="'* ' + $helper.trans('Phone_number')" class="input-big w-100 deliveryAddressInformation_phone_input" />
                        </div>
                        <div class="mb-3">
                            <input type="text" v-model="$store.state.deliveryAddressInformation.email" :placeholder="($store.state.transportationType === 'import' ? '* ' : '') + $helper.trans('Contact_email')" class="input-big w-100 deliveryAddressInformation_email_input" />
                        </div>
                        <div class="mb-3">
                            <input type="text" v-model="$store.state.deliveryAddressInformation.address1" :placeholder="'* ' + $helper.trans('Address') + ' 1'" class="input-big w-100 deliveryAddressInformation_address1_input " />
                        </div>
                        <div class="mb-3" v-show="['us', 'ca', 'ie', 'au'].includes($store.state.to.country)">
                            <input type="text" v-model="$store.state.deliveryAddressInformation.address2" :placeholder="$helper.trans('Address') + ' 2'" class="input-big w-100 deliveryAddressInformation_address2_input" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="mb-3" v-show="!['us', 'ca', 'ie', 'au'].includes($store.state.to.country)">
                            <input type="text" v-model="$store.state.deliveryAddressInformation.address2" :placeholder="$helper.trans('Address') + ' 2'" class="input-big w-100 deliveryAddressInformation_address2_input" />
                        </div>
                        <div class="mb-3">
                            <input type="text" v-model="$store.state.deliveryAddressInformation.address3" :placeholder="$helper.trans('Address') + ' 3'" class="input-big w-100 deliveryAddressInformation_address2_input" />
                        </div>
                        <div class="admin-country-selector" v-if="$store.state.inClientAdmin">
                            <price-calculator-country-selector input-type="to" :disabled="$store.state.selectedShippingType === 'import'"></price-calculator-country-selector>
                        </div>
                        <div class="mb-3" v-else>
                            <input type="text" :value="$store.state.to.countryName" :placeholder="'* ' + $helper.trans('Country')" class="input-big w-100 to_country_input" disabled />
                        </div>
                        <div class="mb-3">
                            <input type="text" v-model="$store.state.to.postCode" :placeholder="($helper.needsCity().to && $store.state.to.country !== 'ma' ? '' : '* ') + $helper.trans('Zip_code')" class="input-big w-100 to_postCode_input" :disabled="!$store.state.inClientAdmin && $store.state.to.country !== 'ma'"  id="post_code_delivery_block">
                        </div>
                        <div class="mb-3 position-relative">
                            <select2-component v-if="$helper.needsCity()['to'] && $store.state.computed.citiesArray.to.length > 0" :values="$store.state.computed.citiesArray.to" :placeholder="'* ' + $helper.trans('City')" :noLang="true" :useIndexes="false" classes="input-big select-style-ups select2-vue deliveryAddressInformation_city_input to_city_input" v-model="$store.state.deliveryAddressInformation.city" dropDownClass="select2-with-search" :lowerCaseIndices="false"></select2-component>

                            <template v-else>
                                <input type="text" v-model="$store.state.deliveryAddressInformation.city" v-on:keydown.9="!['us', 'ca', 'ie', 'au'].includes($store.state.to.country) ? $helper.toggleAccordion(3, true) : '';" :placeholder="'* ' + $helper.trans('City')" class="input-big w-100 deliveryAddressInformation_city_input to_city_input" @focus="focusOnCity = true" @blur="focusOnCity = false" />
                                <template v-if="$store.state.additionalAddressInfo.to !== undefined &&
                                    $store.state.deliveryAddressInformation.city === '' && focusOnCity
                                    ">
                                    <div class="dropdown-city-select" style="z-index: 1000; display: initial; max-height: 100px; overflow-y: auto;">
                                        <ul>
                                            <li v-for="(element, index) in $store.state.additionalAddressInfo.to" @mousedown="$store.state.deliveryAddressInformation.city = element.city" :key="index">
                                                <span class="city-label">{{ element.city }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                            </template>
                        </div>
                        <div class="mb-3" v-show="$store.state.to.country === 'us'">
                            <select2-component 
                                :values="$store.state.$siteSettings['State_list']" 
                                :placeholder="'* ' + $helper.trans('State')" 
                                classes="input-big select-style-ups select2-vue deliveryAddressInformation_stateOrProvince_input" 
                                v-model="$store.state.deliveryAddressInformation.stateOrProvince" 
                                specialName="deliveryAddressInformation" 
                                dropDownClass="country-picker"
                            ></select2-component>
                        </div>
                        <div class="mb-3" v-show="$store.state.to.country === 'ca'">
                            <select2-component 
                                ref="deliveryStateOrProvince"
                                :values="$store.state.$siteSettings['Province_list']" 
                                :placeholder="'* ' + $helper.trans('Province')" 
                                classes="input-big select-style-ups select2-vue deliveryAddressInformation_stateOrProvince_input" 
                                v-model="$store.state.deliveryAddressInformation.stateOrProvince" 
                                specialName="deliveryAddressInformation" 
                                dropDownClass="country-picker"
                            ></select2-component>
                        </div>
                        <div class="mb-3" v-show="$store.state.to.country === 'ie'">
                            <select2-component 
                                :values="$store.state.$siteSettings['Counties_list']" 
                                :placeholder="'* ' + $helper.trans('County')" 
                                classes="input-big select-style-ups select2-vue deliveryAddressInformation_stateOrProvince_input" 
                                v-model="$store.state.deliveryAddressInformation.stateOrProvince" 
                                specialName="deliveryAddressInformation" 
                                dropDownClass="country-picker"
                            ></select2-component>
                        </div>
                        <div class="mb-3" v-show="$store.state.to.country === 'au'">
                            <select2-component 
                                :values="$store.state.$siteSettings['AU_state_list']" 
                                :placeholder="'* ' + $helper.trans('State')" 
                                classes="input-big select-style-ups select2-vue deliveryAddressInformation_stateOrProvince_input" 
                                v-model="$store.state.deliveryAddressInformation.stateOrProvince" 
                                specialName="deliveryAddressInformation" 
                                dropDownClass="country-picker"
                            ></select2-component>
                        </div>
                    </div>
                </div>

                <div class="link-block">
                    <button type="button" @click="$helper.toggleAccordion(1, true);" class="link link-left">{{ $helper.trans('Shipping_address') }}</button>
                    <button type="button" @click="nextStep()" class="link link-right">{{ $helper.trans('Package_information') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function () {
        return {
            focusOnCity: false,
            selectedAddressId: '',
        };
    },
    methods: {
        nextStep() {               
            this.$helper.toggleAccordion(3, true);            
        },
        openAddressSelectorModal: function(addressType){
            this.$store.state.addressSelectorType = addressType;
            $('#address_selector_modal').modal('show');
            this.$store.state.defaultAddressSelector = false;
        },
        isNumber(value) {
            return !Number.isNaN(Number(value));
        },
        setProvinces() {
            let vueThis = this;
            let deliveryStateOrProvince = '';

            if (this.$refs.deliveryStateOrProvince !== undefined) {
                deliveryStateOrProvince = vueThis.$refs.deliveryStateOrProvince;
            }

            vueThis.$store.state.deliveryAddressInformation.stateOrProvince 
                = vueThis.$helper.getCanadaProvinceByPostCode(vueThis.$store.state.to.postCode, deliveryStateOrProvince);

            vueThis.$store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation = true;  
        }
    },
    computed: {
        addressValues() {
            let vueThis = this;
            let values = {};

            let address_type = vueThis.$store.state.selectedShippingType === 'import' ? 'user' : 'receiver';
            $.each(vueThis.$store.state.userAddresses[address_type], function (index, element) {
                values[element.id] = `${element.username_or_company} | ${vueThis.$helper.getCountryCode(element.country)} | ${element.zip_code}`;
            });

            return values;
        },
        isImport(){
            return this.$store.state.to.country === 'lt';
        },
    },
    watch: {
        'selectedAddressId': function () {
            if (this.selectedAddressId) {
                let address_type = this.$store.state.selectedShippingType === 'import' ? 'user' : 'receiver';
                this.$helper.fillAddress(address_type, this.selectedAddressId, this.$store.state.selectedShippingType === 'import');
            }
        },
        '$store.state.deliveryAddressInformation': {
            handler(newValue, oldValue) {
                this.$store.state.checkOutSteps.fourth = false;     
                if (this.$store.state.deliveryFillingAddress) {
                    return;
                }

                this.$store.state.deliveryAddressInformation.saveLikeNewAddress = true;
            },

            deep: true
        },
        '$store.state.deliveryAddressInformation.phone': function () {       
            if (this.$store.state.to.country === 'us')  {
                if (!this.isNumber(this.$store.state.deliveryAddressInformation.phone)) {
                    $('.deliveryAddressInformation_phone_input').parent().addClass('custom-ups-error-parent')
                    $('.deliveryAddressInformation_phone_input').addClass('alert-danger-ups')

                    if ($('.deliveryAddressInformation_phone_input').parent().find('.ups-danger-text').length == 0) {
                        $('.deliveryAddressInformation_phone_input').parent().append(
                            '<span class="ups-danger-text ml-3">' + this.$helper.trans('Wrong_phone_number') + '</span>'
                        );
                    }
                } else {
                    $('.deliveryAddressInformation_phone_input').parent().removeClass('custom-ups-error-parent')
                    $('.deliveryAddressInformation_phone_input').removeClass('alert-danger-ups')
                    $('.deliveryAddressInformation_phone_input').parent().find('.ups-danger-text').remove();
                }
            } else {
                $('.deliveryAddressInformation_phone_input').parent().removeClass('custom-ups-error-parent')
                $('.deliveryAddressInformation_phone_input').removeClass('alert-danger-ups')
                $('.deliveryAddressInformation_phone_input').parent().find('.ups-danger-text').remove();
            }
        },
        '$store.state.to.country': function () { 
            if (this.$store.state.to.country === 'ca') {
                this.setProvinces();
            }
        },
        '$store.state.deliveryAddressInformation.city': function () { 
            if (this.$store.state.to.country === 'ca' && !this.$store.state.inClientAdmin) {
                if (this.$store.state.deliveryAddressInformation.stateOrProvince == "") {
                    this.setProvinces();
                }
            }
        },      
        '$store.state.to.postCode': async function() {
            let vueThis = this;

            if (vueThis.$store.state.to.country === 'mt') {
                vueThis.$store.state.deliveryAddressInformation.city = vueThis.$helper.getMaltaCity(vueThis.$store.state.to.postCode);
            }
            
            if (vueThis.$store.state.to.country === 'ca') {
                vueThis.setProvinces();                                              
            }

            if (this.$store.state.to.country !== 'us') {
                return;
            }

            let valid = await vueThis.$helper.setCitiesFromApi(vueThis.$store.state.to.postCode, 'to');   
            if (valid) {
                vueThis.$forceUpdate();
            }            
        },
        '$store.state.deliveryAddressInformation.stateOrProvince': function () { 
            this.$store.state.awaitingActions.resetShippings = true;
        }
    }
}
</script>